var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"requestauth"}},[_vm._v("Redirecting to Your SAML2 Provider...")])}
var staticRenderFns = []

export { render, staticRenderFns }